var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "bj-query-form bj-query-form-for-cal-height form",
      attrs: { size: "mini", model: _vm.form, rules: _vm.rules },
    },
    [
      _c(
        "el-row",
        { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.Client"),
                    prop: "clientCode",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.clientCodeList,
                      placeholder: _vm.$t("chooseText"),
                    },
                    model: {
                      value: _vm.form.clientCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "clientCode", $$v)
                      },
                      expression: "form.clientCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.creditType"),
                    prop: "creditType",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.creditTypeList,
                      placeholder: _vm.$t("chooseText"),
                    },
                    model: {
                      value: _vm.form.creditType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "creditType", $$v)
                      },
                      expression: "form.creditType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.CreditType"),
                    prop: "GSTType",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": [
                        { label: "Excl.GST", value: "Excl" },
                        { label: "Incl.GST", value: "Incl" },
                      ],
                      placeholder: _vm.$t("chooseText"),
                      clearable: false,
                    },
                    on: { change: _vm.chooseType },
                    model: {
                      value: _vm.GSTType,
                      callback: function ($$v) {
                        _vm.GSTType = $$v
                      },
                      expression: "GSTType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.Credit"),
                    prop: "quantity",
                  },
                },
                [
                  _c("BjInputMoney", {
                    attrs: {
                      disabled: _vm.GSTType == "Incl",
                      placeholder: _vm.$t("billingPage.Credit"),
                      clearable: "",
                    },
                    on: { blur: _vm.getCreditGST },
                    model: {
                      value: _vm.form.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "quantity", $$v)
                      },
                      expression: "form.quantity",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.CreditGST"),
                    prop: "inclQuantity",
                  },
                },
                [
                  _c("BjInputMoney", {
                    attrs: {
                      disabled: _vm.GSTType == "Excl",
                      placeholder: _vm.$t("billingPage.CreditGST"),
                      clearable: "",
                    },
                    on: { blur: _vm.getInclQuantity },
                    model: {
                      value: _vm.form.inclQuantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "inclQuantity", $$v)
                      },
                      expression: "form.inclQuantity",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: _vm.colSpan } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.creditNoe"),
                    prop: "creditNoe",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.STATUS_CREDITNOE_TRUE,
                      placeholder: _vm.$t("chooseText"),
                    },
                    model: {
                      value: _vm.form.creditNoe,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "creditNoe", $$v)
                      },
                      expression: "form.creditNoe",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.form.creditNoe
            ? _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.ApplyWeek"),
                        prop: "year",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          id: "getWeekDate1",
                          "picker-options": _vm.pickerOptions,
                          type: "week",
                          format: "yyyy-WW",
                          clearable: false,
                          placeholder: _vm.$t("billingPage.ApplyWeek"),
                        },
                        model: {
                          value: _vm.weekDataNow,
                          callback: function ($$v) {
                            _vm.weekDataNow = $$v
                          },
                          expression: "weekDataNow",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { padding: "0 10px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.description"),
                    prop: "description",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      autosize: "",
                      "show-word-limit": "",
                      maxlength: _vm.MAX_LENGTH.BILLMAX,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }